import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from "devextreme/ui/dialog";
import { TransportArticle } from "src/app/_api/models/transport-article.model";
import { TransportArticlesService } from "src/app/_api/services/transport-articles.service";
import { TransportService } from "src/app/_api/services/transport.service";
import { TimeService } from "src/app/modules/time/_api/services/time.service";
import { AmsNotifierService } from "src/app/shared/services/ams-notifier.service";
import { LanguageService } from "src/app/shared/services/language.service";

@Component({
  selector: "app-project-portal-approval-employee-articles",
  templateUrl: "./articles.component.html",
  styleUrls: ["./articles.component.css"],
})
export class ProjectPortalApprovalEmployeeArticlesComponent {
  @Input() articles: TransportArticle[];
  @Input() articleTypes: any[];
  @Input() transport: any;
  @Input() selectedTimeRecord: any;
  @Input() allowEdit: boolean;

  @Output() isBusy = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>(); //false if not clearing datagrid selections
  @Output() editingStart = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>(); //emit event to parent(project-portal.component) to show load indicator

  additionText: string;
  isClone: boolean = false;
  cloneData: any;

  @ViewChild("datagriddx", { static: false })
  articlesGrid: DxDataGridComponent;

  constructor(
    public languageService: LanguageService,
    private transportArticlesService: TransportArticlesService,
    private transportService: TransportService,
    private timeService: TimeService,
    private amsNotifierService: AmsNotifierService
  ) {}

  private async loadArticles(): Promise<any> {
    this.articles = await this.transportArticlesService
      .getByTime(this.selectedTimeRecord.TimeId)
      .toPromise();
  }

  onToolbarPreparing(e) {
    if (this.allowEdit) {
      e.toolbarOptions.items.unshift(
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "copy",
            title: this.languageService.LNG("Label.Copy"),
            onClick: this.onCopySelected.bind(this),
          },
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "trash",
            title: this.languageService.LNG("Label.Delete"),
            onClick: this.onDeleteSelected.bind(this),
          },
        }
      );
    }
  }

  onCopySelected() {
    let selectedRowsData = this.articlesGrid.instance.getSelectedRowsData();
    if (selectedRowsData.length > 0) {
      for (let i = 0; i < selectedRowsData.length; i++) {
        this.isClone = true;
        this.cloneData = selectedRowsData[i];
        this.articlesGrid.instance.addRow();
      }
    }
  }

  onDeleteSelected() {
    let myDialog = custom({
      title: this.languageService.LNG("Label.Delete"),
      messageHtml: this.languageService.LNG(
        "Label.Do.You.Want.To.Delete.The.Selected.Rows"
      ),
      buttons: [
        {
          text: this.languageService.LNG("Label.Yes"),
          onClick: (e) => {
            return true;
          },
        },
        {
          text: this.languageService.LNG("Label.No"),
          onClick: (e) => {
            return false;
          },
        },
      ],
    });
    myDialog.show().then((bConfirm) => {
      if (bConfirm) {
        let transportArticleIds: number[] = [];
        let selectedRowsData = this.articlesGrid.instance.getSelectedRowsData();

        if (selectedRowsData.length > 0) {
          this.onLoading(true);

          for (let i = 0; i < selectedRowsData.length; i++) {
            transportArticleIds.push(selectedRowsData[i].TransportArticleId);
          }

          if (transportArticleIds.length > 0) {
            this.timeService
              .deleteTransportArticleByTransportArticleIds(
                this.selectedTimeRecord.CarrierId,
                transportArticleIds
              )
              .subscribe(
                (result: any) => {
                  // success path
                  this.onLoading(false);
                  this.loadArticles();

                  if (result.IsSuccess) {
                    this.amsNotifierService.success(
                      this.languageService.LNG("Label.DeletedOK")
                    );

                    if (result.Message != null && result.Message.length > 0) {
                      this.amsNotifierService.error(result.Message);
                    }
                    this.refresh.emit(false);
                    this.articlesGrid.selectedRowKeys = [];
                  } else {
                    this.amsNotifierService.error(result.ErrorMessage);
                  }
                },
                (error) => {
                  // error path;
                  this.onLoading(false);
                }
              );
          }
        } else {
          this.amsNotifierService.info(
            this.languageService.LNG("Label.Please.Select.Rows.To.Delete")
          );
          this.onLoading(false);
        }
      }
    });
  }

  onEditorPreparing(e) {
    if (e.parentType == "dataRow") {
      e.editorOptions.onFocusIn = function (args) {
        const input = args.element.querySelector(".dx-texteditor-input");
        if (input !== null && input !== undefined) {
          input.select();
        }
      };
    }
  }

  onEditingStart(e) {
    this.editingStart.emit(e);
  }

  onSavingMultiple(e) {
    this.onLoading(true);
    e.cancel = true;
    let newArticles = [];
    let updatedArticles = [];

    e.changes.forEach((row) => {
      let article = {
        TransportArticleId: row.data.TransportArticleId
          ? row.data.TransportArticleId
          : row.key.TransportArticleId,
        CarrierId: this.selectedTimeRecord.CarrierId,
        OldTransportArticleId: row.key.TransportArticleId
          ? row.key.TransportArticleId
          : -1,
        Quantity: row.data.Quantity ? row.data.Quantity : row.key.Quantity,
        TransportStatusId:
          this.transport != null ? this.transport.TransportStatusId : 1,
      };

      if (row.type === "insert") {
        newArticles.push(article);
      }
      if (row.type === "update") {
        updatedArticles.push(article);
      }
    });

    this.transportService
      .saveMultipleCarriedArticles(newArticles, updatedArticles)
      .subscribe(
        (result: any) => {
          // success path
          if (result.IsSuccess) {
            this.onLoading(false);
            this.loadArticles();
            this.amsNotifierService.success(
              this.languageService.LNG("Label.SavedOK")
            );
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            e.component.cancelEditData();
          } else {
            this.amsNotifierService.error(result.ErrorMessage);
          }
        },
        (error) => {
          // error path;
        }
      );
    e.component.refresh(true);
    e.component.cancelEditData();
  }

  async onInitNewRow(e) {
    if (!this.isClone) {
      e.data.CarrierId = this.selectedTimeRecord.CarrierId;
    } else {
      e.data.TransportArticleId = this.cloneData.TransportArticleId;
      e.data.Description = this.cloneData.Description;
      e.data.Quantity = this.cloneData.Quantity;
      e.data.TransportQuantityUnitCode =
        this.cloneData.TransportQuantityUnitCode;
    }

    this.isClone = false;
  }

  setAllowEdit(allow: boolean) {
    this.allowEdit = allow;
  }

  onLoading(loading: boolean) {
    this.loading.emit(loading);
  }
}
